/**
 * CopilotChart — small inline bar/donut chart for Copilot aggregation answers.
 * spec = { kind: 'bar'|'donut', title, data: [{label, value}] }
 */
import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell,
  PieChart, Pie, Legend,
} from 'recharts';

const COLORS = ['#EA580C', '#F97316', '#FB923C', '#FDBA74', '#0EA5E9',
  '#38BDF8', '#22C55E', '#84CC16', '#A855F7', '#EC4899', '#F59E0B', '#64748B'];

const fmt = (n) => {
  if (typeof n !== 'number') return n;
  if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return `${n}`;
};

const CopilotChart = ({ spec }) => {
  if (!spec || !Array.isArray(spec.data) || spec.data.length === 0) return null;
  const data = spec.data.map((d) => ({ ...d, label: String(d.label) }));

  return (
    <div className="mt-2 rounded-lg border border-gray-200 bg-white p-2.5" data-testid="copilot-chart">
      {spec.title && <p className="mb-1 text-[11px] font-medium text-gray-500">{spec.title}</p>}
      <div style={{ width: '100%', height: 180 }}>
        <ResponsiveContainer width="100%" height="100%">
          {spec.kind === 'donut' ? (
            <PieChart>
              <Pie data={data} dataKey="value" nameKey="label" cx="50%" cy="50%"
                   innerRadius={38} outerRadius={62} paddingAngle={2}>
                {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip formatter={(v) => fmt(v)} />
              <Legend wrapperStyle={{ fontSize: 10 }} iconSize={8} />
            </PieChart>
          ) : (
            <BarChart data={data} layout="vertical" margin={{ left: 4, right: 16, top: 4, bottom: 4 }}>
              <XAxis type="number" tick={{ fontSize: 10 }} tickFormatter={fmt} />
              <YAxis type="category" dataKey="label" width={92}
                     tick={{ fontSize: 10 }} interval={0} />
              <Tooltip formatter={(v) => fmt(v)} />
              <Bar dataKey="value" radius={[0, 4, 4, 0]}>
                {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Bar>
            </BarChart>
          )}
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CopilotChart;
